import { ConfigurationType, ExportType } from '@/models'

export const getExportTypeAndConfigurationType = (
  exportType: ExportType,
  configurationType: ConfigurationType,
  SHOW_CONFIGURATION_NAMES: boolean
): ConfigurationType => {
  if (SHOW_CONFIGURATION_NAMES) {
    return `${exportType} (${configurationType})`
  } else {
    return exportType ?? ''
  }
}
